import type { ComponentProps } from 'react'

import { cn } from '@/lib/utils'

// The shared bordered "card" surface, rendered by both the morphing onboarding box (<FlowFrame>) and the plain
// cards, so their look cannot drift. It owns only the surface — each consumer composes its own inner layout.
export function Frame({ className, ...props }: ComponentProps<'div'>) {
  return (
    <div
      data-slot="frame"
      className={cn(
        'bg-card text-card-foreground ring-foreground/10 overflow-hidden rounded-xl py-4 text-sm ring-1',
        className,
      )}
      {...props}
    />
  )
}
